import React, { useState } from 'react';
import { Calendar } from 'react-date-range';
import ModalDefault from '../../modal/modal-default';
import Input from '../input/input';
import { getFormattedDate } from '../../../../helpers/dateTime';

import './DateInput.scss';

const TODAY = new Date();
const MAX_DATE = new Date(TODAY.getFullYear() + 10, TODAY.getMonth());

const DateInput = ({ field, form, ...props }) => {
    const [isDatePickerShown, setIsDatePickerShown] = useState(false);
    const handleFocusChange = () => setIsDatePickerShown(!isDatePickerShown);
    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateSelect = (date) => {
        setSelectedDate(date);
    };

    const handleClose = () => {
        setIsDatePickerShown();
    };

    const handleSave = () => {
        let date = selectedDate;
        if (date === null) {
            date = TODAY;
        }
        form.setFieldValue(field.name, date);
        setIsDatePickerShown();
    };

    return (
        <div className="glu-date-input-wrapper">
            <Input
                {...props}
                onClick={handleFocusChange}
                value={form.values[field.name] ? getFormattedDate(form.values[field.name]) : ''}
                className="glu-date-input g-icon"
                readOnly
            />

            {isDatePickerShown && (
                <ModalDefault
                    isOpen={isDatePickerShown}
                    customClass="glu-date-picker-modal"
                >
                    <>
                        <div className="glu-modal__header">
                            <div className="glu-modal__title glu-flex-grow">
                                Select target date
                            </div>
                            <div className="glu-flex-shrink">
                                <button
                                    aria-label="close"
                                    type="button"
                                    className="glu-btn-link g-icon g-icon-close"
                                    onClick={handleClose}
                                />
                            </div>
                        </div>
                        <div className="glu-modal__body">
                            <div className="glu-content__section">
                                <Calendar
                                    onChange={handleDateSelect}
                                    date={selectedDate || TODAY}
                                    minDate={TODAY}
                                    MAX_DATE={MAX_DATE}
                                />
                            </div>
                        </div>

                        <footer className="glu-modal__footer">

                            <div className="glu-flex-grow glu-flex-row">
                                <div className="glu-flex-grow text-right">
                                    <button
                                        onClick={handleClose}
                                        className="glu-btn glu-btn--secondary"
                                        type="button"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="glu-flex-shrink">
                                    <button
                                        className="glu-btn glu-btn--primary"
                                        type="button"
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </footer>
                    </>
                </ModalDefault>
            )}
        </div>

    );
};

export default DateInput;
